import { render, staticRenderFns } from "./WillBeneficiariesDivorcedDetails.vue?vue&type=template&id=1ebabfc4"
import script from "./WillBeneficiariesDivorcedDetails.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesDivorcedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports